import restfulBase from '@/services/negotiations/core/base';

const apiService = (companyId: string) => restfulBase(`companies/${companyId}/benefits`);

export default apiService;
